// This file was automatically generated from appchart.refpanel.tags.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.tags');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.tags.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var tList5831 = opt_data.tags;
  var tListLen5831 = tList5831.length;
  if (tListLen5831 > 0) {
    for (var tIndex5831 = 0; tIndex5831 < tListLen5831; tIndex5831++) {
      var tData5831 = tList5831[tIndex5831];
      el8.template.ptdata.patients.tag({tag: tData5831}, output);
    }
  } else {
    output.append('<a class="el8StandardFontSize">+ Tags</a>');
  }
  if (!opt_sb) return output.toString();
};
